export default {
  0: {
    ar: "الكل",
    en: "All",
    id: 0,
    order: 0,
    fields: [],
    search: [],
    quick: { base: [], more: [] },
    extended_fields: [],
    uri: "عقارات",
  },
  1: {
    en: "Apartment for rent",
    ar: "شقة للإيجار",
    REGA_category: "شقة",
    id: 1,
    uri: "شقق-للإيجار",
    is_rent: true,
    order: 1,
    fields: [
      "type",
      "price",
      "content",
      "street_width",
      "area",
      "family",
      "rent_period",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "lift",
      "ac",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: [
      "rent_period",
      "beds",
      "family",
      "prices",
      "furnished",
      "livings",
      "wc",
      "car_entrance",
      "fl",
      "age",
      "ac",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    quick: {
      base: ["prices", "beds", "family"],
      more: [
        "car_entrance",
        "fl",
        "age",
        "ac",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
    extended_fields: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "external_area",
      "internal_area",
    ],
  },
  2: {
    en: "Land for sale",
    ar: "أرض للبيع",
    REGA_category: "ارض",
    uri: "أراضي-للبيع",
    id: 2,
    is_rent: false,
    order: 3,
    commercial: true,
    fields: [
      "price",
      "content",
      "street_direction",
      "type",
      "street_width",
      "area",
      "meter_price",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "type",
      "meter_price",
      "price",
      "area",
      "street_direction",
      "street_width",
    ],
    extended_fields: ["fiber_optic", "raw_land"],
    quick: {
      base: ["type", "price", "area", "street_width"],
      more: ["street_direction", "meter_price"],
    },
  },
  3: {
    en: "Villa for sale",
    ar: "فيلا للبيع",
    REGA_category: "فيلا",
    uri: "فلل-للبيع",
    id: 3,
    is_rent: false,
    order: 2,
    commercial: true,
    fields: [
      "price",
      "type",

      "content",
      "street_direction",
      "beds",
      "apts",
      "livings",
      "wc",
      "street_width",
      "stairs",
      "age",
      "driver",
      "maid",
      "pool",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "basement",
      "lift",
      // "duplex",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "villa_type",
    ],
    search: [
      "stairs",
      "apts",
      "price",
      "beds",
      "livings",
      "wc",
      "car_entrance",
      "driver",
      "maid",
      "pool",
      "furnished",
      "area",
      "age",
      "street_direction",
      "ketchen",
      "street_width",
      "basement",
      // "duplex",
      "villa_type",
    ],
    extended_fields: [
      "fiber_optic",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "laundry_room",
      "project_name",
      "upper_extension",
      "lower_extension",
      "balcony",

      "apartments_count",
      "floors_count",
      "external_area",
      "internal_area",
    ],
    quick: {
      base: ["stairs", "apts", "price"],
      more: [
        "beds",
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        "basement",
        // "duplex",
        "villa_type",
      ],
    },
  },
  4: {
    en: "Big flat for rent",
    ar: "دور للإيجار",
    REGA_category: "دور",
    uri: "دور-للإيجار",
    id: 4,
    is_rent: true,
    order: 5,
    fields: [
      "price",
      "type",

      "rent_period",
      "prices",
      "content",
      "street_width",
      "street_direction",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "car_entrance",
      "ac",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: [
      "beds",
      "livings",
      "wc",
      "fl",
      "area",
      "car_entrance",
      "age",
      "price",
      "rent_period",
      "prices",
      "ac",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extended_fields: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "floors_count",
      "external_area",
      "internal_area",
    ],
    quick: {
      base: ["prices", "beds", "fl"],
      more: [
        "car_entrance",
        "age",
        "ac",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
  },
  5: {
    en: "Villa for rent",
    ar: "فيلا للإيجار",
    REGA_category: "فيلا",
    uri: "فلل-للإيجار",
    id: 5,
    is_rent: true,
    order: 4,
    fields: [
      "price",
      "content",
      "type",

      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "stairs",
      "age",
      "driver",
      "maid",
      "pool",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "basement",
      "lift",
      // "duplex",
      "ac",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "villa_type",
    ],
    search: [
      "stairs",
      "beds",
      "livings",
      "wc",
      "price",
      "rent_period",
      "prices",
      "car_entrance",
      "driver",
      "maid",
      "pool",
      "furnished",
      "area",
      "age",
      "street_direction",
      "ketchen",
      "street_width",
      // "duplex",
      "basement",
      "ac",
      "villa_type",
    ],
    extended_fields: [
      "fiber_optic",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "project_name",
      "upper_extension",
      "lower_extension",
      "balcony",
      "external_area",
      "internal_area",
    ],
    quick: {
      base: ["prices", "stairs", "beds", "price"],
      more: [
        "car_entrance",
        "driver",
        "maid",
        "pool",
        "furnished",
        "area",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
        // "duplex",
        "basement",
        "ac",
        "villa_type",
      ],
    },
  },
  6: {
    en: "Apartment for sale",
    ar: "شقة للبيع",
    REGA_category: "شقة",
    uri: "شقق-للبيع",
    id: 6,
    is_rent: false,
    order: 6,
    commercial: true,
    fields: [
      "type",

      "price",
      "content",
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "lift",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: [
      "beds",
      "livings",
      "wc",
      "price",
      "car_entrance",
      "fl",
      "age",
      "area",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extended_fields: [
      "fiber_optic",
      "special_parking",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "external_area",
      "internal_area",
    ],
    quick: {
      base: ["beds", "price"],
      more: [
        "car_entrance",
        "fl",
        "age",
        "area",
        "private_roof",
        "apartment_in_villa",
        "two_entrances",
        "special_entrance",
      ],
    },
  },
  7: {
    en: "Building for sale",
    ar: "عمارة للبيع",
    REGA_category: "عمارة",
    uri: "عمائر-للبيع",
    id: 7,
    is_rent: false,
    order: 7,
    commercial: true,
    fields: [
      "price",
      "content",
      "street_direction",
      "type",
      "street_width",
      "apts",
      "furnished",
      "age",
      "stores",
      "rooms",
      "basement",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "type",
      "price",
      "area",
      "apts",
      "stores",
      "street_width",
      "age",
      "street_direction",
    ],
    extended_fields: [],
    quick: {
      base: ["type", "price"],
      more: [
        "area",
        "apts",
        "stores",
        "street_width",
        "age",
        "street_direction",
      ],
    },
  },
  8: {
    en: "Store for rent",
    ar: "محل للإيجار",
    REGA_category: "معرض",
    uri: "محلات-للإيجار",
    id: 8,
    is_rent: true,
    order: 12,
    commercial: true,
    fields: [
      "price",
      "type",

      "content",
      "street_direction",
      "street_width",
      "age",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["street_width", "area"],
    extended_fields: [],
    quick: { base: ["street_width", "area"], more: [] },
  },
  9: {
    en: "Small house for sale",
    ar: "بيت للبيع",
    REGA_category: "فيلا",
    uri: "بيت-للبيع",
    id: 9,
    is_rent: false,
    order: 8,
    fields: [
      "price",
      "content",
      "type",

      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "age",
      "driver",
      "maid",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "beds",
      "livings",
      "area",
      "tent",
      "furnished",
      "age",
      "street_direction",
      "price",
      "street_width",
    ],
    extended_fields: [],
    quick: {
      base: ["beds", "area"],
      more: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "price",
        "street_width",
      ],
    },
  },
  10: {
    en: "Lounge for sale",
    ar: "استراحة للبيع",
    REGA_category: "استراحة",
    uri: "استراحة-للبيع",
    id: 10,
    is_rent: false,
    order: 11,
    fields: [
      "price",
      "type",

      "content",
      "street_direction",
      "livings",
      "wc",
      "street_width",
      "pool",
      "fb",
      "vb",
      "tent",
      "age",
      "playground",
      "beds",
      "family_section",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["price", "area", "street_width", "age"],
    extended_fields: [],
    quick: { base: ["price", "area"], more: ["street_width"] },
  },
  11: {
    en: "Small house for rent",
    ar: "بيت للإيجار",
    REGA_category: "فيلا",
    uri: "بيت-للإيجار",
    id: 11,
    is_rent: true,
    order: 10,
    fields: [
      "type",

      "price",
      "content",
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "age",
      "driver",
      "maid",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "beds",
      "livings",
      "area",
      "tent",
      "furnished",
      "age",
      "street_direction",
      "ketchen",
      "price",
      "street_width",
    ],
    extended_fields: [],
    quick: {
      base: ["beds", "area"],
      more: [
        "tent",
        "furnished",
        "age",
        "street_direction",
        "ketchen",
        "street_width",
      ],
    },
  },
  12: {
    en: "Farm for sale",
    ar: "مزرعة للبيع",
    REGA_category: "مزرعة",
    uri: "مزرعة-للبيع",
    id: 12,
    is_rent: false,
    order: 13,
    fields: [
      "price",
      "content",
      "type",

      "street_width",
      "tent",
      "wells",
      "trees",
      "area",
      "meter_price",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["meter_price", "area", "price"],
    extended_fields: [],
    quick: { base: ["area"], more: ["price", "meter_price"] },
  },
  13: {
    en: "Lounge for rent",
    ar: "استراحة للإيجار",
    REGA_category: "استراحة",
    uri: "استراحة-للإيجار",
    id: 13,
    is_rent: true,
    order: 9,
    fields: [
      "price",
      "content",
      "street_width",
      "type",

      "age",
      "rent_period",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "family_section",
      "rent_period",
      "price",
      "area",
      "pool",
      "fb",
      "prices",
      "vb",
      "tent",
      "ketchen",
      "playground",
    ],
    extended_fields: [],
    quick: {
      base: ["family_section", "rent_period", "price"],
      more: ["area", "pool", "fb", "vb", "tent", "ketchen", "playground"],
    },
  },
  14: {
    en: "Office for rent",
    ar: "مكتب للإيجار",
    REGA_category: "مكتب",
    uri: "مكتب-تجاري-للإيجار",
    id: 14,
    is_rent: true,
    order: 17,
    commercial: true,
    fields: [
      "price",
      "type",

      "content",
      "street_direction",
      "street_width",
      "age",
      "furnished",
      "area",
      "meter_price",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["furnished", "price", "meter_price", "street_width", "area"],
    extended_fields: [],
    quick: {
      base: ["furnished", "meter_price", "street_width", "area"],
      more: [],
    },
  },
  15: {
    en: "Land for rent",
    ar: "أرض للإيجار",
    REGA_category: "ارض",
    uri: "أراضي-للإيجار",
    id: 15,
    is_rent: true,
    order: 15,
    commercial: true,
    fields: [
      "price",
      "content",
      "street_direction",
      "type",
      "street_width",
      "area",
      "meter_price",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["meter_price", "type", "area", "street_direction", "street_width"],
    extended_fields: ["fiber_optic", "raw_land"],
    quick: {
      base: ["meter_price", "type", "area"],
      more: ["street_direction", "street_width"],
    },
  },
  16: {
    en: "Building for rent",
    ar: "عمارة للإيجار",
    REGA_category: "عمارة",
    uri: "عمائر-للإيجار",
    id: 16,
    is_rent: true,
    order: 14,
    commercial: true,
    fields: [
      "price",
      "content",
      "street_direction",
      "type",
      "street_width",
      "apts",
      "furnished",
      "age",
      "stores",
      "rooms",
      "basement",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "type",
      "area",
      "apts",
      "stores",
      "street_width",
      "age",
      "street_direction",
      "price",
    ],
    extended_fields: [],
    quick: {
      base: ["type", "area"],
      more: ["apts", "stores", "street_width", "age", "street_direction"],
    },
  },
  17: {
    en: "Warehouse for rent",
    ar: "مستودع للإيجار",
    REGA_category: "مستودع",
    uri: "مستودع-للإيجار",
    id: 17,
    is_rent: true,
    order: 19,
    fields: [
      "type",

      "price",
      "content",
      "street_direction",
      "street_width",
      "age",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["price", "street_width", "area"],
    extended_fields: [],
    quick: { base: ["street_width", "area"], more: [] },
  },
  18: {
    en: "Tent for rent",
    ar: "مخيم للإيجار",
    REGA_category: "استراحة",
    uri: "مخيم-للإيجار",
    id: 18,
    is_rent: true,
    order: 18,
    fields: [
      "type",

      "price",
      "content",
      "area",
      "rent_period",
      "family_section",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["rent_period", "family_section"],
    extended_fields: [],
    quick: { base: ["rent_period", "family_section"], more: [] },
  },
  19: {
    en: "Room for rent",
    ar: "غرفة للإيجار",
    REGA_category: "غرفة",
    uri: "غرف-للإيجار",
    id: 19,
    is_rent: true,
    order: 16,
    fields: [
      "price",
      "type",

      "content",
      "street_width",
      "area",
      "rent_period",
      "age",
      "furnished",
      "ketchen",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["rent_period", "ketchen", "price"],
    extended_fields: [],
    quick: { base: ["rent_period", "ketchen"], more: [] },
  },
  20: {
    en: "Store for sale",
    ar: "محل للتقبيل",
    REGA_category: "معرض",
    uri: "محلات-للبيع",
    id: 20,
    is_rent: false,
    order: 20,
    fields: [
      "type",

      "price",
      "content",
      "street_direction",
      "street_width",
      "age",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["price", "street_width", "area"],
    extended_fields: [],
    quick: { base: ["price", "street_width", "area"], more: [] },
  },
  21: {
    en: "Furnished apartment for rent",
    ar: "شقة مفروشة",
    REGA_category: "شقة",
    uri: "شقة-مفروشة",
    id: 21,
    is_rent: true,
    order: 21,
    fields: [
      "type",

      "price",
      "content",
      "street_width",
      "area",
      "rent_period",
      "family",
      "beds",
      "livings",
      "fl",
      "age",
      "extra_unit",
      "car_entrance",
      "ac",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "price",
      "rent_period",
      "family",
      "livings",
      "fl",
      "age",
      "extra_unit",
      "car_entrance",
      "ac",
    ],
    extended_fields: [],
    quick: {
      base: [
        "price",
        "rent_period",
        "family",
        "livings",
        "fl",
        "age",
        "extra_unit",
        "car_entrance",
        "ac",
      ],
      more: [],
    },
  },
  22: {
    en: "Floor for sale",
    ar: "دور للبيع",
    REGA_category: "دور",
    uri: "دور-للبيع",
    id: 22,
    is_rent: false,
    order: 22,
    fields: [
      "price",
      "content",
      "type",
      "area",
      "street_direction",
      "street_width",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "car_entrance",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: ["price", "area", "livings", "age", "fl", "car_entrance"],
    extended_fields: [
      "fiber_optic",
      "special_parking",
      "ac_type",
      "accept_bank",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "apartments_count",
      "floors_count",
      "external_area",
      "internal_area",
    ],
    quick: {
      base: ["price", "area", "livings", "fl", "age", "car_entrance"],
      more: [],
    },
  },
  23: {
    en: "Chalet for rent",
    ar: "شاليه للإيجار",
    REGA_category: "استراحة",
    uri: "شاليه-للإيجار",
    id: 23,
    is_rent: true,
    order: 23,
    fields: [
      "type",

      "price",
      "content",
      "street_width",
      "age",
      "rent_period",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: [
      "family_section",
      "rent_period",
      "price",
      "area",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
    ],
    extended_fields: [],
    quick: {
      base: ["family_section", "rent_period", "price"],
      more: ["area", "pool", "fb", "vb", "tent", "ketchen", "playground"],
    },
  },
  24: {
    en: "Other",
    ar: "أخرى",
    REGA_category: "أخرى",
    uri: "أخرى",
    id: 24,
    is_rent: false,
    order: 24,
    fields: [
      "price",
      "content",
      "street_width",
      "age",
      "area",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
    ],
    search: ["area", "price"],
    extended_fields: [],
    quick: {
      base: [],
      more: [],
    },
  },
  101: {
    en: "Apartment for booking",
    ar: "شقة مفروشة للحجز",
    REGA_category: null,
    uri: "شقق-للحجز",
    id: 101,
    is_rent: true,
    order: 101,
    fields: [
      "price",
      "content",
      "street_width",
      "area",
      "family",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "lift",
      "ac",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: [
      "beds",
      "family",
      "price",
      "furnished",
      "livings",
      "wc",
      "car_entrance",
      "fl",
      "age",
      "ac",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extended_fields: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "wifi",
      "washing_machine",
      "smart_tv",
      "self_entry",
      "oven",
      "heater",
      "iron",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  102: {
    en: "Villa for booking",
    ar: "فيلا مفروشة للحجز",
    REGA_category: null,
    uri: "فلل-للحجز",
    id: 102,
    is_rent: true,
    order: 102,
    fields: [
      "price",
      "content",
      "street_direction",
      "beds",
      "livings",
      "wc",
      "street_width",
      "stairs",
      "age",
      "driver",
      "maid",
      "pool",
      "furnished",
      "tent",
      "backyard",
      "ketchen",
      "extra_unit",
      "car_entrance",
      "basement",
      "lift",
      // "duplex",
      "ac",
      "area",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "playground",
      "family",
      "villa_type",
    ],
    search: [
      "stairs",
      "beds",
      "livings",
      "wc",
      "price",
      "car_entrance",
      "driver",
      "maid",
      "pool",
      "furnished",
      "area",
      "age",
      "street_direction",
      "ketchen",
      "street_width",
      // "duplex",
      "basement",
      "ac",
      "villa_type",
    ],
    extended_fields: [
      "fiber_optic",
      "ac_type",
      "accept_bank",
      "roof_villa",
      "project_name",
      "upper_extension",
      "lower_extension",
      "balcony",

      "bedrooms_count",
      "guestsrooms_count",
      "driversrooms_count",
      "other_rooms_count",
      "special_parking",
      "wifi",
      "washing_machine",
      "smart_tv",
      "self_entry",
      "oven",
      "heater",
      "projector",
      "iron",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  103: {
    en: "Studio for booking",
    ar: "استديو مفروش للحجز",
    REGA_category: null,
    uri: "استديوهات-للحجز",
    id: 103,
    is_rent: true,
    order: 103,
    fields: [
      "price",
      "content",
      "street_width",
      "area",
      "family",
      "beds",
      "livings",
      "wc",
      "fl",
      "age",
      "furnished",
      "ketchen",
      "extra_unit",
      "lift",
      "ac",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    search: [
      "beds",
      "family",
      "price",
      "furnished",
      "livings",
      "wc",
      "car_entrance",
      "fl",
      "age",
      "ac",
      "private_roof",
      "apartment_in_villa",
      "two_entrances",
      "special_entrance",
    ],
    extended_fields: [
      "separated_electrical_meter",
      "separated_water_meter",
      "fiber_optic",
      "special_parking",
      "ac_type",
      "roof_villa",
      "laundry_room",
      "apartment_in_project",
      "project_name",
      "balcony",
      "wifi",
      "washing_machine",
      "smart_tv",
      "self_entry",
      "oven",
      "heater",
      "iron",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  104: {
    en: "Chalet for booking",
    ar: "شاليه للحجز",
    REGA_category: null,
    uri: "شاليهات-للحجز",
    id: 104,
    is_rent: true,
    order: 104,
    fields: [
      "price",
      "content",
      "street_width",
      "age",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "men_place",
      "women_place",
      "rooms",
      "family",
      "car_entrance",
    ],
    search: [
      "family_section",
      "price",
      "area",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
    ],
    extended_fields: [
      "wifi",
      "smart_tv",
      "oven",
      "sleeping",
      "heater",
      "sound_system",
      "microphone",
      "grill",
      "outdoor_cooling_system",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "private_beach",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  105: {
    en: "Lounge for booking",
    ar: "استراحة للحجز",
    REGA_category: null,
    uri: "استراحات-للحجز",
    id: 105,
    is_rent: true,
    order: 105,
    fields: [
      "price",
      "content",
      "street_width",
      "age",
      "livings",
      "beds",
      "wc",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
      "family_section",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "men_place",
      "women_place",
      "rooms",
      "family",
      "car_entrance",
    ],
    search: [
      "family_section",
      "price",
      "area",
      "pool",
      "fb",
      "vb",
      "tent",
      "ketchen",
      "playground",
    ],
    extended_fields: [
      "special_parking",
      "wifi",
      "smart_tv",
      "oven",
      "sleeping",
      "heater",
      "microphone",
      "sound_system",
      "grill",
      "outdoor_cooling_system",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "private_beach",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },

  106: {
    en: "Tent for booking",
    ar: "مخيم للحجز",
    REGA_category: null,
    uri: "مخيمات-للحجز",
    id: 106,
    is_rent: true,
    order: 106,
    fields: [
      "price",
      "content",
      "area",
      "family_section",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "ketchen",
      "beds",
      "livings",
      "men_place",
      "women_place",
      "pool",
      "fb",
      "vb",
      "tent",
      "rooms",
      "playground",
      "family",
      "car_entrance",
      "wc",
    ],
    search: ["family_section"],
    extended_fields: [
      "special_parking",
      "wifi",
      "smart_tv",
      "oven",
      "sleeping",
      "heater",
      "microphone",
      "sound_system",
      "projector",
      "grill",
      "outdoor_cooling_system",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "private_beach",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  107: {
    en: "Farm for booking",
    ar: "مزرعة للحجز",
    REGA_category: null,
    uri: "مزارع-للحجز",
    id: 107,
    is_rent: true,
    order: 107,
    fields: [
      "price",
      "content",
      "street_width",
      "tent",
      "wells",
      "trees",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "ketchen",
      "beds",
      "livings",
      "men_place",
      "women_place",
      "pool",
      "fb",
      "vb",
      "rooms",
      "playground",
      "family",
      "car_entrance",
      "wc",
    ],
    search: ["meter_price", "area", "price"],
    extended_fields: [
      "special_parking",
      "wifi",
      "smart_tv",
      "oven",
      "sleeping",
      "heater",
      "microphone",
      "sound_system",
      "grill",
      "outdoor_cooling_system",
      "smoking",
      "special_view",
      "cleaning_service",
      "microwave",
      "shampoo",
      "towels",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
  108: {
    en: "Hall for booking",
    ar: "قاعة للحجز",
    REGA_category: null,
    uri: "قاعات-للحجز",
    id: 108,
    is_rent: true,
    order: 108,
    fields: [
      "price",
      "content",
      "street_width",
      "tent",
      "wells",
      "trees",
      "area",
      "width",
      "length",
      "water_availability",
      "electrical_availability",
      "drainage_availability",
      "ketchen",
      "livings",
      "family",
      "car_entrance",
    ],
    search: ["meter_price", "area", "price"],
    extended_fields: [
      "special_parking",
      "wifi",
      "smart_tv",
      "heater",
      "microphone",
      "sound_system",
      "projector",
      "smoking",
      "special_view",
      "cleaning_service",
      "cctv",
      "instant_booking",
    ],
    quick: { base: [], more: [] },
  },
};
